export default __webpack_public_path__ + "static/media/react.b651ed8f.png";